// Hosts-Liste + Bookmarks fuer /daten/files. Beides statisch genug
// dass 60s-Polling reicht; Verzeichnis-Listings sind per-Click und
// haben kein First-Paint-Problem -- die bleiben in Files.svelte.
//
// SWR: ja -- Page rendert beim Reload sofort die Host-Dropdowns + die
// gespeicherten Favoriten statt erst auf den Initial-Fetch zu warten.

import { SvelteMap } from "svelte/reactivity";
import { registerRevalidator } from "./revalidate.svelte";

import { loadPersisted, persist } from "./persistent-summary.svelte";
import type { FilesHost } from "./types";

export interface FilesPaneRef {
  host_id: string;
  path: string;
}

export interface FilesBookmark {
  label: string;
  left: FilesPaneRef;
  right: FilesPaneRef;
}

const KEY_HOSTS = "files-hosts";
const KEY_BOOKMARKS = "files-bookmarks";

const _hosts = new SvelteMap<string, FilesHost[]>();
const _bookmarks = new SvelteMap<string, FilesBookmark[]>();
let _started = false;
let _timer: ReturnType<typeof setInterval> | undefined;

async function refresh(): Promise<void> {
  try {
    const hRes = await fetch("/v2-api/files/hosts", { credentials: "include" });
    if (hRes.ok) {
      const list = (await hRes.json()) as FilesHost[];
      _hosts.set("current", list);
      persist(KEY_HOSTS, list);
    }
  } catch {
    /* ignore */
  }
  try {
    const bRes = await fetch("/v2-api/files/bookmarks", { credentials: "include" });
    if (bRes.ok) {
      const list = (await bRes.json()) as FilesBookmark[];
      _bookmarks.set("current", list);
      persist(KEY_BOOKMARKS, list);
    }
  } catch {
    /* ignore */
  }
}

export function startFilesSummary(): void {
  if (_started) return;
  _started = true;
  registerRevalidator(refresh);
  const cachedHosts = loadPersisted<FilesHost[]>(KEY_HOSTS);
  if (cachedHosts) _hosts.set("current", cachedHosts);
  const cachedBookmarks = loadPersisted<FilesBookmark[]>(KEY_BOOKMARKS);
  if (cachedBookmarks) _bookmarks.set("current", cachedBookmarks);
  void refresh();
  _timer = setInterval(refresh, 60_000);
}

export function stopFilesSummary(): void {
  _started = false;
  if (_timer) {
    clearInterval(_timer);
    _timer = undefined;
  }
  _hosts.clear();
  _bookmarks.clear();
}

export function getFilesHosts(): FilesHost[] | undefined {
  return _hosts.get("current");
}

export function getFilesBookmarks(): FilesBookmark[] | undefined {
  return _bookmarks.get("current");
}

export function refreshFilesSummary(): Promise<void> {
  return refresh();
}
